module.exports = "https://coursera_assets.s3.amazonaws.com/images/5f93bc943204e2f80f1ea440d26116b3.png";